import { Dispatch } from 'react';

type Dictionary<T> = {
    [key: string]: T;
};

export type CsvFile = {
    name: File | null;
    data: Dictionary<string | number>[];
};

export enum ContactTypeEnum {
    PROSPECTS = 'prospects',
    AMBASSADORS = 'ambassadors',
    NON_AMBASSADORS = 'non-ambassadors',
}

export type UploadWizardState = {
    contactType: ContactTypeEnum;
    usedTemplate: boolean;
    pickedGroup?: number | unknown;
    pickedGroups: (number | unknown)[];
    csvFile: CsvFile;
    needToCrawl: boolean;
};

export type UploadWizardAction =
    | { type: 'contact-type'; payload: ContactTypeEnum }
    | { type: 'used-template'; payload: { usedTemplate: boolean } }
    | { type: 'picked-group'; payload: number }
    | { type: 'picked-groups'; payload: (number | unknown)[] }
    | { type: 'csv'; payload: { csvFile: CsvFile } }
    | { type: 'need-to-crawl'; payload: boolean };

export type UploadWizardContextType = {
    state: UploadWizardState;
    dispatch: Dispatch<UploadWizardAction>;
};
